// How wide an area photos of a place can be taken from. A restaurant or a
// museum is a point; a mountain, lake, park or island has one coordinate (the
// summit, the centre) but its photos are taken from towns and viewpoints tens
// of km away (Mount Fuji from Lake Kawaguchi is ~18 km from the summit). For
// those, a 10 km limit would drop the classic views and ranking by distance
// would bury them, so the search area is wider and distance stops counting.

const LARGE_NAME =
  /\b(mount|mt|mont|monte|monti|mountains?|volcano|volcanoes|lakes?|lago|lac|rivers?|rio|park|parc|parque|national|islands?|isla|isle|valley|canyon|gorge|glacier|beach|bay|coast|cape|desert|forest|reserve|reef|falls|region|archipelago|peninsula)\b/i;
const LARGE_CATEGORY =
  /\b(mountains?|volcano(es)?|parks?|nature|islands?|lakes?|rivers?|beach(es)?|coast|forests?|deserts?|valleys?|canyons?|reserves?|regions?|hiking|trails?)\b/i;

// Search radius in km for photos of this place.
export function searchRadiusKm(name, categoryNames) {
  return LARGE_NAME.test(name || "") || LARGE_CATEGORY.test(categoryNames || "") ? 50 : 10;
}
